import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "./ChartFooter.css";
import * as actionCreators from "../../../store/analytics/chart-footer/action-creators";
import { WHITEBOARDS_MAX_LIMIT } from "../../../services/managers/constants";
import { TOOLTIP_ADD_SECOND_CHART, TOOLTIP_REMOVE_SECOND_CHART } from "../../../services/managers/string-literals";

class ChartFooter extends React.Component {
  render() {
    // Hide 'Add Second Chart' button when side-by-side comparison is enabled
    let addNewButtonDoc = null;
    if (this.props.whiteboardsLength < WHITEBOARDS_MAX_LIMIT) {
      addNewButtonDoc = (
        <div className={"grid"}>
          <div className={"grid__col-md-12 grid__col-sm-12 " + styles["grid-col-section-left"]}>
            <button
              className="btn btn--link"
              onClick={() => this.props.onAddNewWhiteboardClick(this.props.whiteboardIndex)}
              title={TOOLTIP_ADD_SECOND_CHART}>
              <i className="fa fa-plus" aria-hidden="true" /> Add Second Chart
            </button>
          </div>
        </div>
      );
    }

    // Show 'Remove Chart' button when side-by-side comparison is enabled
    let removeButtonDoc = null;
    if (this.props.whiteboardIndex !== 0) {
      removeButtonDoc = (
        <div className={"grid"}>
          <div className={"grid__col-md-12 grid__col-sm-12 " + styles["grid-col-section-left"]}>
            <button
              type="button"
              className="btn btn--link btn--link--negative"
              onClick={() => this.props.onRemoveWhiteboardClick(this.props.whiteboardIndex)}
              title={TOOLTIP_REMOVE_SECOND_CHART}>
              <i className="fa fa-times" aria-hidden="true" /> Remove Chart
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className={styles["chart-footer-component-container"]}>
        {addNewButtonDoc} {removeButtonDoc}
      </div>
    );
  }
}

ChartFooter.propTypes = {
  whiteboardsLength: PropTypes.number.isRequired
};

const mapStateToProps = (state) => ({
  whiteboardsLength: state.analytics.chartWhiteboards.length
});

const mapDispatchToProps = (dispatch) => ({
  onAddNewWhiteboardClick: (whiteboardIndex) => dispatch(actionCreators.onAddNewWhiteboardClick({ whiteboardIndex })),
  onRemoveWhiteboardClick: (whiteboardIndex) => dispatch(actionCreators.onRemoveWhiteboardClick({ whiteboardIndex }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChartFooter);



// WEBPACK FOOTER //
// ./src/components/Analytics/ChartFooter/ChartFooter.js